$(document).ready(function(){
	$('.series_menu a').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		//var headerHeight = $('#header').height();
		var position = target.offset().top - headerHeight;
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
		
	});	

});

$(window).on("load", function() {
		var hash = location.hash;
		if(hash){
            console.log(hash);
			var target = $(hash);
			var position = target.offset().top - headerHeight;
            setTimeout(function(){
                $("html, body").animate({scrollTop:position}, 0, "swing");
            },100);
			
		}
});

  


$(function(){
  
  var list = $('.series_list');
  var item = $('.series_list .series_item');
  var item_img = $('.series_list .series_item .series_photo');
  var col_num = 4;
  var img_height_group = 0;
  var hidden_height = $('.series_list .series_item:eq(0)').width() * 0.3;
  var img_height = 0;
  var col_total = 0;
  var mediaQuery = window.matchMedia('(max-width: 740px)');
  var currentRowItems = [];
  var currentRow = 0;
  var btn_height = 30;
  
  $(window).on('resize', function(){
	  hidden_height = $('.series_list .series_item:eq(0)').width() * 0.3;
	  
	  list.each(function(){
		  currentRowItems = [];
	  　　currentRow = 0;
	  	  items = $(this).find('.series_item');
		  $(this).find('.series_item').each(function(index,elm){
			  
		  	currentRowItems.push(elm);
		
		    if ((index + 1) % col_num === 0 || index === items.length - 1) {
		      adjustHeight(currentRowItems);
		      currentRowItems = [];
		      currentRow++;
		    }
		    
		  });
	  });
  });

  function handle(mm) {
    if (mm.matches) {
    	col_num = 2;
    	btn_height = 25;
    } else {
    	col_num = 4;
    	btn_height = 30;
    }
  }
  
  function adjustHeight(targets) {
	  let maxTitleHeight = 0;
	
	  $(targets).each(function(index,target){
		
	    const title = $(target).find(".series_variation");
	    const title2 = $(target).find(".series_variation_wrap");
		
		if($(target).hasClass('is-hide')){
			if(!$(target).hasClass('open')){
				elm_height = hidden_height;
			}else{
				var elm = title.find("img");
				var elm_height = 0;
				if(elm.length){
					elm_height = elm.height() + btn_height;
				}else{
					elm_height = 0;
				}
			}
			
		}else{
			var elm = title.find("img");
			var elm_height = 0;
			if(elm.length){
				elm_height = elm.height();
			}else{
				elm_height = 0;
			}
		}
	    title.height('0');
	    title2.height('0');
		
	    maxTitleHeight = Math.max(maxTitleHeight, elm_height);
	  });
	
	  $(targets).each(function(index,target){
	    const title = $(target).find(".series_variation");
	    const title2 = $(target).find(".series_variation_wrap");
		title.css('height',maxTitleHeight + 'px');
		title2.css('height',maxTitleHeight + 'px');
	  });
　}
　
　handle(mediaQuery);
  
  mediaQuery.addListener(handle);
  
  item.each(function(){
	  if($(this).find('.series_variation').length == 0){
		  $(this).find('.series_photo').after('<div class="series_variation_wrap"><div class="series_variation"></div></div>');
	  }else{
		  $(this).find('.series_variation').wrap('<div class="series_variation_wrap">');
	  }
  })
  
  list.each(function(){
	  col_total = 0;
	  $(this).find('.series_item').each(function(){
		  col_total += 1;
		  img_height_elm = $(this).find('.series_variation img');
		  if(img_height_elm.length){
			  img_height = img_height_elm.height();
		  }else{
			  img_height = 0;
		  }
		  
		  if(img_height > hidden_height){
			  $(this).addClass('is-hide');
		  }else{
			  $(this).removeClass('is-hide');
		  }
		  /*
		  if(col_num < col_total){
			  col_total = 0;
			  img_height_group = 0;
		  }
		  */
	  })
  })
  list.each(function(){
	  currentRowItems = [];
  　　currentRow = 0;
  	  items = $(this).find('.series_item');
	  $(this).find('.series_item').each(function(index,elm){
		  currentRowItems.push(elm);
		  if ((index + 1) % col_num === 0 || index === items.length - 1) {
		    adjustHeight(currentRowItems);
		    currentRowItems = [];
		    currentRow++;
		  }
	  })
  })
  
  $('.series_item.is-hide .series_variation').click(function(){
	  var index = $(this).parents('.series_list').find('.series_variation').index(this);
	  var start = 0;
	  var end = 0;
	  var syou = 0;
	  var amari = 0;
	  
	  syou = Math.floor(index / col_num);
	  amari = index % col_num;
	  
	  start = syou * col_num;
	  end = ((syou + 1) * col_num);
	  if(end > $(this).parents('.series_list').find('.series_variation').length){
		  end = $(this).parents('.series_list').find('.series_variation').length;
	  }
	  
	  var max_height = 0;
	  var elm_height = 0;
	  
	  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).not($(this).parents('.series_variation_wrap')).each(function(){
		  if($(this).parents('.series_item').hasClass('open')){
			  elm_height = $(this).find('img').height() + btn_height;
		  }else{
			  elm_height = 0;
		  }
		  max_height = Math.max(max_height, elm_height);
	  })
	  
		  
	  if($(this).parents('.series_item').hasClass('open')){
		  
		  var this_height = hidden_height;
	  
		  if(this_height > max_height ){
			  max_height = this_height;
		  }
		  
		  $(this).parents('.series_item').removeClass('open');
		  $(this).stop().animate({height: this_height + "px"} , 200);
		  if(max_height == 0 ){
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', 'auto');
		  }else{
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).stop().animate({height: max_height + "px"} , 200);
		  }
		  /*
		  $(this).stop().animate({height: this_height + "px"}, {
		  duration: 200,
		    complete: function() {
			    $(this).parents('.series_item').removeClass('open');
				  if(max_height == 0 ){
					  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', 'auto');
				  }else{
					  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', max_height + 'px');
				  }
		  	}
		  }); 
		  */
	  }else{
		  
		  var this_height = $(this).find('img').height() + btn_height;
		  
		  if(this_height > max_height ){
			  max_height = this_height;
		  }
		  
		  $(this).parents('.series_item').addClass('open');
		  $(this).stop().animate({height: this_height + "px"}, 200); 
		  if(max_height == 0 ){
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', 'auto');
		  }else{
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).stop().animate({height: max_height + "px"}, 200); 
		  }
		  
		  /*
		  if(max_height == 0 ){
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', 'auto');
		  }else{
			  $(this).parents('.series_list').find('.series_variation_wrap').slice(start,end).css('height', max_height + 'px');
		  }
		  
		  $(this).stop().animate({height: this_height + "px"}, 200); 
		  $(this).parents('.series_item').addClass('open');
		  */
		  
	  }
	  
	  
	  
	  /*
	  $(this).css('height', this_height + 'px');
	  */
  })
  
});